export default "__VITE_ASSET__CAxIRTi3__"